import { COMMON_ERROR_ICON, feedbackMenuIcon, helpIcon, logoutIcon, mailIcon } from './commonImage';

// #region "API TENANT ID"
export const TENANT = process.env.REACT_APP_TENANT;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const X_TENANT_ID = process.env.REACT_APP_TENANT;
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL; // "https://euwdsatstewap02.azurewebsites.net/";
export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;
export const PRODUCTION = 'production';
// #endregion "API TENANT ID"

// #region "APP URLs"
export const EMBRYONIC_APP_URL = process.env.REACT_APP_EMBRYONIC_APP_URL;
export const KC_APP_URL = process.env.REACT_APP_KC_APP_URL;
export const PEVC_APP_URL = process.env.REACT_APP_PEVC_APP_URL;
export const SUSTAINABILITY_APP_URL = process.env.REACT_APP_SUSTAINABILITY_APP_URL;
export const GENERATE_APP_URL = process.env.REACT_APP_GENERATE_APP_URL;
export const SI_APP_URL = process.env.REACT_APP_SI_APP_URL;
export const SUI_APP_URL = process.env.REACT_APP_SUI_APP_URL;
export const DISCOVERY_URL = process.env.REACT_APP_DISCOVERY_ROUTE;
export const SECONDARY_RESEARCH_APP_URL = process.env.REACT_APP_SECONDARY_RESEARCH_APP_URL;
export const VALUE_ACCELERATOR_APP_URL = process.env.REACT_APP_VALUE_ACCELERATOR_APP_URL;
export const SAT_PORTAL_ROUTE = process.env.REACT_APP_SAT_PORTAL_ROUTE;
export const REACT_APP_POLLING_TIME_IN_SECOND: any =
  process.env.REACT_APP_POLLING_TIME_IN_SECOND ?? 60;
// #endregion "APP URLs"

// #region "Custom Defined Types"
export const profileMenuList = [
  {
    id: 1,
    item: 'Contact us',
    icon: mailIcon
  },
  {
    id: 2,
    item: 'Logout',
    icon: logoutIcon
  }
];
// #endregion "Custom Defined Types"

export const SOMETHING_WENT_WRONG = 'Something went wrong.';
export const PLEASE_TRY_AFTER_SOMETIME = 'Please try after sometime.';

//#region "ErroPages"

export const PAGE_NOT_FOUND = 'Page Not Found';
export const INTERNAL_SERVER_ERROR = 'Internal Server Error';
export const ERROR_STATUS = {
  CODE_500: {
    HEADING: 'Internal server error',
    SUBHEADING: '500',
    DESCRIPTION1: 'Internal server error.',
    DESCRIPTION2:
      'There is a problem with the resource you are looking for and it can not be displayed.',
    ICON: COMMON_ERROR_ICON
  },
  CODE_404: {
    HEADING: 'Page Not Found',
    SUBHEADING: ':-( 404',
    DESCRIPTION1: 'Ooops! Page Not Found',
    DESCRIPTION2:
      'Sorry.. but the page you are looking for does not exist, has been removed, or is temporarily unavailable',
    ICON: COMMON_ERROR_ICON
  }
};

export const RESPONSE_STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  RELOAD_DATA: 429,
  UNAVAILABLE: 451,
  INTERNAL_SERVER_ERROR: 500,
  FORBIDDEN: 403
};

export const MAX_TEXT_LENGTH = 1000;
export const MIN_SYMBOLS_TO_START_SEARCHING = 2;
export const contentAge = [
  { label: 'Last 6 months', value: '0' },
  { label: '1 year', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
  { label: '3+ years', value: '4' }
];
export const surveyPeriod = [
  { label: '6 months', value: '0' },
  { label: '1 year', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
  { label: 'More than 3 years', value: '4' }
];
export const surveyPeriod1 = [
  // { label: 'Select All', value: '0', isChecked: false },
  { label: '6 months', value: '0', isChecked: false },
  { label: '1 year', value: '1', isChecked: false },
  { label: '2 years', value: '2', isChecked: false },
  { label: '3 years', value: '3', isChecked: false }
];
export const expertContentAge = [
  { label: 'Last 6 months', value: '0' },
  { label: '1 year', value: '1' },
  { label: '2 years', value: '2' },
  { label: '3 years', value: '3' },
  { label: '3+ years', value: '4' }
];
export const eypProspectiveQueries = [
  { query: 'What is the global plant-based protein market size?' },
  {
    query: 'Which segment is fast growing in freeze-dried pet food?'
  },
  { query: 'How is the sustainable fiber value chain segmented?' }
];

export const expertsQueries = [
  { query: 'Find me experts in pet-care' },
  {
    query: 'Find me experts who have worked on electric vehicle due diligence projects'
  },
  { query: 'Find me experts on diabetes treatments' }
];
export const sectorQueries = [
  { query: 'What are some of the recent trends in debt financing?' },
  {
    query: 'What percentage of electric vehicle growth does the US represent?'
  },
  { query: 'What are the elements of the fiber cable value chain?' }
];
export const surveyQueries = [
  { query: `What do CEO's see as the greatest global challenges facing their companies?` },
  {
    query: 'How do Chief Sustainability Officers feel about the rate of emission reduction?'
  },
  {
    query:
      'What are company executives planning to prioritize to address political risk management?'
  }
];
// #endregion "ErroPages"
export const LOCAL_STORAGE = {
  USER_PROFILE_PIC: 'userProfilePic'
};
export const FEEDBACK_ATTACHMENT_MAX_LIMIT = 2000000; // 2 MB

export const SectorConfig = [{
  id: "1",
  content: "Automotive",
}, {
  id: "2",
  content: "Materials",
},
{
  id: "3",
  content: "Financial",
},
{
  id: "4",
  content: "Energy",
},
{
  id: "5",
  content: "Healthcare",
},
{
  id: "6",
  content: "Real Estate",
},
{
  id: "9",
  content: "Consumer Staples",
},
{
  id: "10",
  content: "Consumer Discretionary",
},
{
  id: "11",
  content: "Industrial",
},
{
  id: "12",
  content: "Information Technology",
},
{
  id: "13",
  content: "Communication Services",
},
{
  id: "14",
  content: "Utilities",
},
{
  id: "15",
  content: "Government and public sector",
}
];
export const ENVIRONMENTS = {
  LOCAL: "LOCAL",
  DEV: "DEV",
  QA: "QA",
  UAT: "UAT",
  PROD: "PROD",
};
export const ENGAGEMENT_MANAGEMENT_GUIDANCE_URL = 'https://discovercontent.ey.net/knd24073j61gtw5l';
export const openAIIconRobot = 'data:image/svg+xml;base64,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'
export const downloadIcon = `data:image/svg+xml,%3Csvg width='10' height='12' viewBox='0 0 10 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.875 4.28125H9.625L4.8125 9.09375L0 4.28125H2.75V0.15625H6.875V4.28125ZM0 11.8438V10.4688H9.625V11.8438H0Z' fill='%23F6F6FA'/%3E%3C/svg%3E%0A`;
export const COPY_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE4NzUgNS4yQzQuMTg3NSA0LjY0MDgxIDQuNjQwODEgNC4xODc1IDUuMiA0LjE4NzVIMTIuNTVDMTMuMTA5MiA0LjE4NzUgMTMuNTYyNSA0LjY0MDgxIDEzLjU2MjUgNS4yVjEyLjU1QzEzLjU2MjUgMTMuMTA5MiAxMy4xMDkyIDEzLjU2MjUgMTIuNTUgMTMuNTYyNUg1LjJDNC42NDA4MSAxMy41NjI1IDQuMTg3NSAxMy4xMDkyIDQuMTg3NSAxMi41NVY1LjJaTTUuMzEyNSA1LjMxMjVWMTIuNDM3NUgxMi40Mzc1VjUuMzEyNUg1LjMxMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNDM3NSAxLjQ1QzAuNDM3NSAwLjg5MDgxMiAwLjg5MDgxMiAwLjQzNzUgMS40NSAwLjQzNzVIOC44QzkuMzU5MTkgMC40Mzc1IDkuODEyNSAwLjg5MDgxMiA5LjgxMjUgMS40NVY0Ljc1QzkuODEyNSA1LjA2MDY2IDkuNTYwNjYgNS4zMTI1IDkuMjUgNS4zMTI1QzguOTM5MzQgNS4zMTI1IDguNjg3NSA1LjA2MDY2IDguNjg3NSA0Ljc1VjEuNTYyNUgxLjU2MjVWOC42ODc1SDQuNzVDNS4wNjA2NiA4LjY4NzUgNS4zMTI1IDguOTM5MzQgNS4zMTI1IDkuMjVDNS4zMTI1IDkuNTYwNjYgNS4wNjA2NiA5LjgxMjUgNC43NSA5LjgxMjVIMS40NUMwLjg5MDgxMiA5LjgxMjUgMC40Mzc1IDkuMzU5MTkgMC40Mzc1IDguOFYxLjQ1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==';
export const COPY_SUCCESS_ICON = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNDE2XzQxNDA3KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC44NTIyNSA4Ljk3NzI1QzUuMDcxOTIgOC43NTc1OCA1LjQyODA4IDguNzU3NTggNS42NDc3NSA4Ljk3NzI1TDcuNSAxMC44Mjk1TDEyLjM1MjMgNS45NzcyNUMxMi41NzE5IDUuNzU3NTggMTIuOTI4MSA1Ljc1NzU4IDEzLjE0NzcgNS45NzcyNUMxMy4zNjc0IDYuMTk2OTIgMTMuMzY3NCA2LjU1MzA4IDEzLjE0NzcgNi43NzI3NUw3Ljg5Nzc1IDEyLjAyMjdDNy42NzgwOCAxMi4yNDI0IDcuMzIxOTIgMTIuMjQyNCA3LjEwMjI1IDEyLjAyMjdMNC44NTIyNSA5Ljc3Mjc1QzQuNjMyNTggOS41NTMwOCA0LjYzMjU4IDkuMTk2OTIgNC44NTIyNSA4Ljk3NzI1WiIgZmlsbD0iIzQ4RTY3NCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgMi4wNjI1QzUuMTY4NTIgMi4wNjI1IDIuMDYyNSA1LjE2ODUyIDIuMDYyNSA5QzIuMDYyNSAxMi44MzE1IDUuMTY4NTIgMTUuOTM3NSA5IDE1LjkzNzVDMTIuODMxNSAxNS45Mzc1IDE1LjkzNzUgMTIuODMxNSAxNS45Mzc1IDlDMTUuOTM3NSA1LjE2ODUyIDEyLjgzMTUgMi4wNjI1IDkgMi4wNjI1Wk0wLjkzNzUgOUMwLjkzNzUgNC41NDcyIDQuNTQ3MiAwLjkzNzUgOSAwLjkzNzVDMTMuNDUyOCAwLjkzNzUgMTcuMDYyNSA0LjU0NzIgMTcuMDYyNSA5QzE3LjA2MjUgMTMuNDUyOCAxMy40NTI4IDE3LjA2MjUgOSAxNy4wNjI1QzQuNTQ3MiAxNy4wNjI1IDAuOTM3NSAxMy40NTI4IDAuOTM3NSA5WiIgZmlsbD0iIzQ4RTY3NCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyNDE2XzQxNDA3Ij4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=';
export const closeIcon = `data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z' fill='white'/%3E%3C/svg%3E`;
export const mrDataSources = [{ label: 'TBRC', value: 'TBRC' }];
export const FEEDBACK_SOURCE_KEY = 'Source';
export const USER_GUIDE_URL = 'https://discovercontent.ey.net/knd25084frtvx4uk';
export const helpDropdownIcon="data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%228%22%20viewBox%3D%220%200%2012%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0.558058%201.05806C0.802136%200.813981%201.19786%200.813981%201.44194%201.05806L6%205.61612L10.5581%201.05806C10.8021%200.813981%2011.1979%200.813981%2011.4419%201.05806C11.686%201.30214%2011.686%201.69786%2011.4419%201.94194L6.44194%206.94194C6.19786%207.18602%205.80214%207.18602%205.55806%206.94194L0.558058%201.94194C0.313981%201.69786%200.313981%201.30214%200.558058%201.05806Z%22%20fill%3D%22%23A4A3B1%22%2F%3E%3C%2Fsvg%3E";
const bookIcon = "data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_12972_10735)%22%3E%3Cpath%20d%3D%22M19.25%204.58333C18.2325%204.2625%2017.1141%204.125%2016.0416%204.125C14.2541%204.125%2012.3291%204.49167%2011%205.5C9.67079%204.49167%207.74579%204.125%205.95829%204.125C4.17079%204.125%202.24579%204.49167%200.916626%205.5V18.9292C0.916626%2019.1583%201.14579%2019.3875%201.37496%2019.3875C1.46663%2019.3875%201.51246%2019.3417%201.60413%2019.3417C2.84163%2018.7458%204.62913%2018.3333%205.95829%2018.3333C7.74579%2018.3333%209.67079%2018.7%2011%2019.7083C12.2375%2018.9292%2014.4833%2018.3333%2016.0416%2018.3333C17.5541%2018.3333%2019.1125%2018.6083%2020.3958%2019.2958C20.4875%2019.3417%2020.5333%2019.3417%2020.625%2019.3417C20.8541%2019.3417%2021.0833%2019.1125%2021.0833%2018.8833V5.5C20.5333%205.0875%2019.9375%204.8125%2019.25%204.58333ZM2.74996%2016.9583V6.41667C3.75829%206.09583%204.85829%205.95833%205.95829%205.95833C7.18663%205.95833%208.82746%206.33417%2010.0833%206.86583V17.4075C8.82746%2016.8758%207.18663%2016.5%205.95829%2016.5C4.85829%2016.5%203.75829%2016.6375%202.74996%2016.9583ZM19.25%2016.9583C18.2416%2016.6375%2017.1416%2016.5%2016.0416%2016.5C14.8133%2016.5%2013.1725%2016.8758%2011.9166%2017.4075V6.86583C13.1725%206.325%2014.8133%205.95833%2016.0416%205.95833C17.1416%205.95833%2018.2416%206.09583%2019.25%206.41667V16.9583Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20opacity%3D%220.3%22%20d%3D%22M10.0833%206.86583C8.8275%206.33417%207.18667%205.95833%205.95833%205.95833C4.85833%205.95833%203.75833%206.09583%202.75%206.41667V16.9583C3.75833%2016.6375%204.85833%2016.5%205.95833%2016.5C7.18667%2016.5%208.8275%2016.8758%2010.0833%2017.4075V6.86583Z%22%20fill%3D%22%233A3A4A%22%2F%3E%3Cpath%20d%3D%22M16.0416%209.625C16.8483%209.625%2017.6274%209.7075%2018.3333%209.86333V8.47C17.6091%208.3325%2016.8299%208.25%2016.0416%208.25C14.8683%208.25%2013.7866%208.39667%2012.8333%208.68083V10.12C13.7408%209.79917%2014.8316%209.625%2016.0416%209.625Z%22%20fill%3D%22%233A3A4A%22%2F%3E%3Cpath%20d%3D%22M16.0416%2012.0633C16.8483%2012.0633%2017.6274%2012.1458%2018.3333%2012.3017V10.9083C17.6091%2010.7708%2016.8299%2010.6883%2016.0416%2010.6883C14.8683%2010.6883%2013.7866%2010.835%2012.8333%2011.1192V12.5583C13.7408%2012.2467%2014.8316%2012.0633%2016.0416%2012.0633Z%22%20fill%3D%22%233A3A4A%22%2F%3E%3Cpath%20d%3D%22M16.0416%2014.5108C16.8483%2014.5108%2017.6274%2014.5933%2018.3333%2014.7492V13.3558C17.6091%2013.2183%2016.8299%2013.1358%2016.0416%2013.1358C14.8683%2013.1358%2013.7866%2013.2825%2012.8333%2013.5667V15.0058C13.7408%2014.685%2014.8316%2014.5108%2016.0416%2014.5108Z%22%20fill%3D%22%233A3A4A%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_12972_10735%22%3E%3Crect%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
const helpMoreResourcesIcon = 'data:image/svg+xml,%3Csvg%20width%3D%2222%22%20height%3D%2222%22%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_13102_442)%22%3E%3Cpath%20d%3D%22M20.1666%206.41666H11.9166V8.25H20.1666V6.41666Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M20.1666%2013.75H11.9166V15.5833H20.1666V13.75Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M20.1666%2010.0833H14.6666V11.9167H20.1666V10.0833Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M11.9166%2011L7.33331%206.41666V10.0833H1.83331V11.9167H7.33331V15.5833L11.9166%2011Z%22%20fill%3D%22white%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_13102_442%22%3E%3Crect%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E';
export const helpMenuList = [
  {
    id: 1,
    item: "User guide",
    icon: bookIcon,
  },
  {
    id: 2,
    item: "More resources",
    icon: helpMoreResourcesIcon,
  }
];
export const MORE_RESOURCE_URL = 'https://sites.ey.com/sites/DS_SaT/Pages/ey-competitive-edge.aspx';
